var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "desc-list"
  }, [_c('v-card-title', {
    staticClass: "desc-list__title"
  }, [_c('span', [_vm._v("필드 목록")]), _vm.mobile ? [_c('v-spacer'), _c('v-btn', {
    staticClass: "my-n1 mr-n1",
    attrs: {
      "text": "",
      "icon": "",
      "tile": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('exit');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)] : _vm._e()], 2), _c('v-divider'), _c('v-card-text', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "gap": "8px",
      "overflow-y": "auto"
    }
  }, [_vm._l(_vm.sides, function (side) {
    return [_c('list-side', _vm._b({
      key: side,
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.form,
        callback: function ($$v) {
          _vm.form = $$v;
        },
        expression: "form"
      }
    }, 'list-side', {
      side,
      mobile: _vm.mobile
    }, false))];
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }